
import { Component, Vue, Prop } from "vue-property-decorator";
import { plainToInstance } from "class-transformer";

import subscription_routes from "@/api/routes/subscriptions";

import NotificationNotification from "@/models/notification/notification";
import SubscriptionProgram from "@/models/subscriptions/program";
import { ESubscriptionStatus } from "@/models/subscriptions/status";

@Component({
  name: "CProgramMaterialsChange"
})
export default class CProgramMaterialsChange extends Vue {
  @Prop({ required: true }) public notification!: NotificationNotification;

  public subscription_program: SubscriptionProgram | null = null;
  public new_materials_count: number = 0;
  public progress: number = 0;

  protected async created() {
    await this.loadSubscriptionProgram();
  }

  private async loadSubscriptionProgram() {
    return this.$api
      .get(
        subscription_routes.subscription_program(
          this.notification.targetable_id
        ),
        {
          params: {
            units: true,
            inspectors: false
          }
        }
      )
      .then(({ data: res }: { data: SubscriptionProgram }) => {
        this.subscription_program = plainToInstance(SubscriptionProgram, res);

        this.new_materials_count = this.subscription_program.subscription_units.filter(
          su => su.is_new
        ).length;

        this.progress = Math.round(
          (this.subscription_program.subscription_units.filter(
            su => su.status === ESubscriptionStatus.DONE
          ).length /
            (this.subscription_program.subscription_units.length ?? 1)) *
            100
        );
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  public closeProgram() {
    this.$emit("close", true);
  }

  public showProgram() {
    this.$emit("onVisited", true);
  }
}
